import { AlphaDIcon } from './AlphaDIcon';

/**
 * author: GreenTurtwig
 * id 0A79E0A4-CE86-431C-A152-57492815C31E
 * name alpha-d
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-d.svg
 * tags
 * - Automotive 
 * - Alpha / Numeric 
 */
export const AlphabetDIcon = AlphaDIcon;
export default AlphabetDIcon